jQuery(document).ready(function ($) {
	$(".growl-component-navbar__toggle-wrapper").on("click", function () {
		$(this).parent().siblings(".growl-component-navbar__right").toggleClass("growl-component-navbar__right--open");
	});
});
